import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../components/Common/Button'
import Modal from '../../../components/Modal';
import ReactTooltip from 'react-tooltip';
import RenderFile from '../../../pages/OnboardingForm/RenderFile';
import LenderUgroService from '../../../services/lender';
import { toast } from 'react-toastify';
import { unSecuredIds } from '../../../constant/constants';
import { downloadFile } from '../../../common/download';
import Hint from '../../../components/Hint';
import ErrorHint from '../../../components/ErrorHint';

const CgPanInfo = ({row, reloadTable, selectedLender}) => {
    const [modalState, setModalState] = useState(false)
    const [viewModalState, setViewModalState] = useState(false)
    const [batchId, setBatchId] = useState(row?.doa_additional_info?.batch_id || '')
    const [panNumber, setPanNumber] = useState(row?.doa_additional_info?.cgpan_number?.toUpperCase() || '')
    const [approvedAmount, setApprovedAmount] = useState(row?.doa_additional_info?.credit_to_be_guaranteed || '')
    const [uploadedFileId, setUploadedFileId] = useState(row?.doa_additional_info?.file_id || '');
    const [file, setFile] = useState('');
    const [fileType, setFileType] = useState(null);
    const [preview, setPreview] = useState('');
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState(null)
    const fileInputRef = useRef(null);

    const handleIconClick = () => {
        fileInputRef.current.click();
    };

    useEffect(()=>{
        setPanNumber(row?.doa_additional_info?.batch_id || '')
        setPanNumber(row?.doa_additional_info?.cgpan_number?.toUpperCase() || '')
        setApprovedAmount(row?.doa_additional_info?.credit_to_be_guaranteed || '')
        setUploadedFileId(row?.doa_additional_info?.file_id || '');
    }, [row?.doa_additional_info?.file_id])

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        const type = selectedFile?.type;
        if (['jpg', 'jpeg', 'pdf'].includes(type?.split('/')[1]) && selectedFile) {
            setFile(selectedFile);
            setFileType(type);
            const objectUrl = URL.createObjectURL(selectedFile);
            setPreview(objectUrl);
        } else {
            fileInputRef.current = null;
            setFile('')
            toast.error("Please Upload only .jpg, .jpeg, .pdf files.")
        }
    };

    const handleSubmitPanInfo = async () => {
        setLoading(true)
        let formData = new FormData();
        formData.append('cl_lead_id', row?.cl_lead_id)
        formData.append('cl_lender_id', selectedLender)
        formData.append('batch_id', batchId)
        formData.append('cgpan_number', panNumber)
        formData.append('credit_to_be_guaranteed', approvedAmount)
        formData.append('file', file)
        try {
            let response = await LenderUgroService.submitCgPanInfo(formData);
            if (response?.data?.status?.code == 1) {
                let successMessages = response?.data?.messages.success
                toast.success(successMessages?.form?.[0] || successMessages?.others?.[0])
                reloadTable();
                setLoading(false);
                handleCloseModal()
            }
        } catch (error) {
            let errors = error?.response?.data?.messages?.error;
            setErrors(errors)
            toast.error(errors?.fields?.[0] || errors?.form?.[0] || errors?.others?.[0] || "Something went wrong")
            setLoading(false);
        }
    }

    const toggleModal = () => {
        setViewModalState(!modalState);
    };

    const handleUploadedFileDownload = async () => {
        try {
            let response = await LenderUgroService.downloadFileById({
                type: 'admin',
                fileId: row?.doa_additional_info?.file_id,
                responseType: 'blob'
            });
            downloadFile(response?.data, 'Upload_Receipt')
        } catch (error) {
            toast.error(error.message)
        }
    }

    const handleCloseModal = () => {
        setErrors(null)
        setFile('')
        setFileType(null)
        setPreview('')
        setModalState(false)
    }

    return (
        unSecuredIds.includes(row?.prod_type) && [1,23].includes(Number(selectedLender)) &&
        <div className='d-flex justify-content-center align-items-center'>
            <ReactTooltip id="edit">Edit</ReactTooltip>
            <ReactTooltip id="add">Add</ReactTooltip>
            <div>
                {row?.doa_additional_info ?
                    <i
                        className="fa fa-pencil fa-lg mr-2"
                        style={{ color: "#4A4E88", cursor: 'pointer' }}
                        data-tip
                        data-for="edit"
                        onClick={() => { setModalState(true) }}
                    ></i>
                    :
                    <i
                        className="fa fa-plus fa-lg mr-2"
                        style={{ color: "#4A4E88", cursor: 'pointer' }}
                        data-tip
                        data-for="add"
                        onClick={() => { setModalState(true) }}
                    ></i>
                }
            </div>
            <Modal
                style={{
                    minWidth: "20%",
                    padding: "0px",
                    backgroundColor: "transparent",
                    // width: '600px',
                    width: '350px',
                    minHeight: '100px'
                }}
                state={modalState}
                closeModal={handleCloseModal}
                removeBorderSpace={true}
                closeOnOverlayClick={false}
            >
                <>
                    <div className="modal-header-container">
                        <div className="modal-title">{selectedLender == 1 ? 'CGPAN Info' : 'Batch Info'}</div>
                        <div className="closeModalView" onClick={handleCloseModal}>
                            <span className="closeModalIcon">x</span>
                        </div>
                    </div>
                    <div className='p-4 modalData' style={{ overflowY: "auto", overflowX: "clip", maxHeight: "92vh" }}>
                        <div>
                            {selectedLender == 23 ?
                            <div class='form-group'>
                                <label>Batch ID
                                    {
                                        errors?.fields?.['batch_id']?.[0] &&
                                        <ErrorHint text={`${errors?.fields?.['batch_id']?.[0]}`} id={'batchIdError'} place={'top'} />
                                    }
                                </label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            type="text"
                                            class="form-control"
                                            value={batchId}
                                            onChange={(e) => { setBatchId(e.target.value) }}
                                            maxLength={15}
                                        />
                                    </div>
                                </div>
                            </div>
                            :
                            <>
                            <div class='form-group'>
                                <label>CGPAN
                                    {
                                        errors?.fields?.['cgpan_number']?.[0] &&
                                        <ErrorHint text={`${errors?.fields?.['cgpan_number']?.[0]}`} id={'cgPanError'} place={'top'} />
                                    }
                                </label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            type="text"
                                            class="form-control"
                                            value={panNumber}
                                            onChange={(e) => { setPanNumber(e.target.value.toUpperCase()) }}
                                            maxLength={50}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class='form-group'>
                                <label>Guarantee Approved Amount {' '}
                                    <Hint text={'Loan Amount approved for coverage by CGTMSE.'} id={'gaa'} place={'top'} />
                                    {
                                        errors?.fields?.['credit_to_be_guaranteed']?.[0] &&
                                        <ErrorHint text={`${errors?.fields?.['credit_to_be_guaranteed']?.[0]}`} id={'gaaError'} place={'top'} />
                                    }
                                </label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            type="text"
                                            class="form-control"
                                            value={approvedAmount}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setApprovedAmount(value);
                                                }
                                            }}
                                            maxLength={13}
                                            pattern='^\d+$'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class='form-group'>
                                <label>Upload Receipt
                                    {
                                        errors?.fields?.['file']?.[0] &&
                                        <ErrorHint text={`${errors?.fields?.['file']?.[0]}`} id={'fileError'} place={'top'} />
                                    }
                                </label>
                                <div class='row'>
                                    <div class='col-12'>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            class="form-control"
                                            onChange={handleFileChange}
                                            accept='.jpg, .jpeg, .pdf'
                                        />
                                        {
                                            file &&
                                            <>
                                                {/* <ReactTooltip id="view">View</ReactTooltip> */}
                                                <i
                                                    className="fa fa-eye fa-lg"
                                                    style={{ color: "#4A4E88", cursor: 'pointer', marginRight: '20px' }}
                                                    // data-tip
                                                    // data-for="view"
                                                    onClick={() => setViewModalState(true)}
                                                ><span className='downloadReceipt'>View Receipt</span></i>
                                            </>
                                        }
                                        {
                                            uploadedFileId &&
                                            <>
                                                {/* <ReactTooltip id="downloadFile">Download</ReactTooltip> */}
                                                <i
                                                    className="fa fa-download fa-lg mt-2 mb-2"
                                                    style={{ color: "#4A4E88", cursor: 'pointer' }}
                                                    // data-tip
                                                    // data-for="downloadFile"
                                                    onClick={() => handleUploadedFileDownload()}
                                                ><span className='downloadReceipt'> Download Receipt</span></i>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            </>
                            }
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12 text-center m-auto'>
                                <button
                                    className='btn btn-custom btn-custom-height p-0 m-auto'
                                    disabled={loading}
                                    onClick={handleSubmitPanInfo}
                                >
                                    {loading ? <div className='loader'></div> : 'Submit'}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            </Modal>
            <Modal
                style={{
                    minWidth: "20%",
                    padding: "0px",
                    backgroundColor: "transparent",
                    width: '75%',
                    minHeight: '100px'
                }}
                state={viewModalState}
                closeModal={() => setViewModalState(false)}
                removeBorderSpace={true}
            >
                {
                    file &&
                    <RenderFile
                        extension={fileType?.split('/')[1] || ''}
                        fileUrl={preview}
                        closeModal={toggleModal}
                    />
                }
            </Modal>
        </div>
    )
}

export default CgPanInfo